import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4d21dc9a&scoped=true&lang=pug&"
import script from "./App.vue?vue&type=script&lang=coffee&"
export * from "./App.vue?vue&type=script&lang=coffee&"
import style0 from "./App.vue?vue&type=style&index=0&id=4d21dc9a&lang=sass&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21dc9a",
  null
  
)

export default component.exports